import { Table } from "antd";
import React from "react";
import styles from "../Dashboard.module.css";

const columns = [
  {
    title: "ZONE NAME",
    dataIndex: "zone_name",
  },
  {
    title: "VISITS",
    dataIndex: "impressions",
    align: "center",
  },
  {
    title: "CLICKS",
    dataIndex: "clicks",
    align: "center",
  },
  {
    title: "REVENUE",
    dataIndex: "revenue",
    align: "center",
  },
];
const refactorTableData = tableData => {
  const tableDataRefactored = tableData
    ? tableData.map((el, index) => {
        const refactor = { ...el };
        refactor.revenue =
          refactor.revenue && "$ " + Number(refactor.revenue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return {
          key: index,
          ...refactor,
        };
      })
    : "";
  return tableDataRefactored;
};

export const TopChannelsTable = ({ loading, tableData }) => {
  return (
    <div className={styles.channelsTableContainer}>
      <h4>Top 10 Zones</h4>
      <Table
        loading={loading}
        columns={columns}
        dataSource={refactorTableData(tableData)}
        pagination={false}
        rowKey={({ zone_name }) => zone_name}
        scroll={{ x: "max-content", scrollToFirstRowOnChange: true }}
      />
    </div>
  );
};
